import script from "./PersonSelector.vue?vue&type=script&setup=true&lang=js"
export * from "./PersonSelector.vue?vue&type=script&setup=true&lang=js"

import "./PersonSelector.vue?vue&type=style&index=0&id=fa77479a&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-fa77479a"]])

export default __exports__